import React, { Component, useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TextInput, ChangePassword } from '../../components/textInput';
import { AuthForm } from '../../components/authForm';
import { Btn } from '../../components/global';
import { withProfile } from "../profile";

const styles = {
    signInContainer: {
        margin: '200px auto'
    },
    navbar: {
        marginBottom: 50,
        width: 500,
        margin: 'auto'
    },
    inputFields: {
        marginBottom: 50,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between'
    },
    button: {
        width: '100%'
    },
    inputFields: {
        marginBottom: 100
    }
};

export default withProfile(withStyles(styles)((props) => {
    const {
        classes,
        fieldsInfo,
        changePasswordHandler,
        setInputField,
        loading,
        state,
        newPassword,
        confirmPassword
    } = props;
    const {
        PWD_MUST, 
        PWD_LENGTH_RULE, 
        PWD_NUMBER_RULE, 
        PWD_UPPERCASE_RULE,
        PWD_LOWERCASE_RULE,
        NEW_PWD, CONFIRM_PWD, CHANGE_PWD
    } = props.messagePool;
    const [pwdValidation, setPwdValidation] = useState("");
    function validatePassword(event) {
        const value = event.target.value;
        let len, digit, uppercase, lowercase;
        len = value.length >= 8;
        digit = /^(?=.*\d).+$/.test(value);
        uppercase = /^(?=.*[A-Z])/.test(value);
        lowercase = /^(?=.*[a-z])/.test(value);
        if (len && digit && uppercase && lowercase) {
            setPwdValidation("")
        } else {
            let message = `${PWD_MUST}: `;
            if (!len) {
                message += `${PWD_LENGTH_RULE}, `
            } 
            if (!digit || !uppercase || !lowercase) {
                message += `${digit ? "" : `${PWD_NUMBER_RULE}, `}${uppercase? "" : `${PWD_UPPERCASE_RULE}, `}${lowercase? "": PWD_LOWERCASE_RULE}`
            }
            setPwdValidation(message);
        }
    }
    return (
        <AuthForm title={"Change Password"}>
            <div className={classes.inputFields}>
                <ChangePassword 
                    onChangePwd={setInputField("newPassword")} 
                    onChangeConfirmPwd={setInputField("confirmPassword")}
                    onKeyDown={(e) => { 
                        if (e.keyCode == 13) {
                            changePasswordHandler();
                        }
                    }}
                />
            </div>
            <Btn variant="contained" 
                color="primary"
                className={classes.button}
                onClick={changePasswordHandler}
                disabled={pwdValidation.length != 0 || newPassword != confirmPassword}>
                {loading? <CircularProgress color="secondary" /> : CHANGE_PWD}
            </Btn>
        </AuthForm>
    )
}))